"use strict";
"use client";
import { DownloadTrigger as DownloadTrigger$1 } from '@ark-ui/react/download-trigger';
import { createRecipeContext } from '../../styled-system/create-recipe-context.js';

const { withContext } = createRecipeContext({ key: "downloadTrigger" });
const DownloadTrigger = withContext(DownloadTrigger$1, { forwardAsChild: true });

export { DownloadTrigger };
